import flatpickr from 'flatpickr'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'

document.addEventListener('DOMContentLoaded', function () {
  const picker = document.querySelector('#datetimepicker')

  function getUrlParameter(name) {
    const params = new URLSearchParams(window.location.search)
    return params.get(name)
  }

  const tarihParam = getUrlParameter('tarih')
  const decodedTarih = tarihParam
    ? decodeURIComponent(tarihParam.replace(/\+/g, ' '))
    : null

  if (!picker) {
    return
  }

  const startTime = picker.dataset.rentStart || '08:00' // Örnek olarak 08:00
  const endTime = picker.dataset.rentEnd || '00:00'
  const activeDays = JSON.parse(
    picker.dataset.rentDays ||
      '["mon", "tue", "wed", "thu", "fri", "sat", "sun"]'
  )

  const now = new Date()
  const [startHour] = startTime.split(':').map(Number)

  const defaultDateTime = new Date(now)
  const currentHour = now.getHours()
  if (currentHour < startHour) {
    defaultDateTime.setHours(startHour, 0, 0, 0)
  } else {
    defaultDateTime.setHours(currentHour + 1, 0, 0, 0)
  }

  const fp = flatpickr('#datetimepicker', {
    locale: Turkish,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    time_24hr: true,
    minuteIncrement: 60,
    defaultDate: decodedTarih || defaultDateTime,
    minDate: 'today',
    enable: [
      function (date) {
        const dayMap = {
          mon: 1,
          tue: 2,
          wed: 3,
          thu: 4,
          fri: 5,
          sat: 6,
          sun: 0,
        }
        return activeDays.map((day) => dayMap[day]).includes(date.getDay())
      },
    ],
    onOpen: function (selectedDates, dateStr, instance) {
      const currentDate = new Date()
      const selectedDate = selectedDates[0] || defaultDateTime

      if (selectedDate.toDateString() === currentDate.toDateString()) {
        if (currentHour >= startHour) {
          instance.set('minTime', `${currentHour + 1}:00`)
        } else {
          instance.set('minTime', startTime)
        }
      } else {
        instance.set('minTime', startTime)
      }
      instance.set('maxTime', endTime)
    },
    onChange: function (selectedDates, dateStr, instance) {
      const [startHour] = startTime.split(':').map(Number)
      const selectedHour = selectedDates[0].getHours()
      const currentDate = new Date()

      if (selectedDates[0].toDateString() === currentDate.toDateString()) {
        if (currentHour >= startHour && selectedHour <= currentHour) {
          instance.setDate(
            new Date(selectedDates[0]).setHours(currentHour + 1, 0, 0, 0),
            true
          )
        }
      }

      if (selectedDates[0].toDateString() === currentDate.toDateString()) {
        if (currentHour >= startHour) {
          instance.set('minTime', `${currentHour + 1}:00`)
        } else {
          instance.set('minTime', startTime)
        }
      } else {
        instance.set('minTime', startTime)
      }
    },
  })
})
